import React from 'react'
import PropTypes from 'prop-types'

const ErrorAlert = ({ message }) => (
  <div className="alert alert-danger" role="alert">
    <i className="fas fa-exclamation-triangle mr-2" />
    {message}
  </div>
)

ErrorAlert.propTypes = {
  message: PropTypes.string.isRequired
}

export default ErrorAlert